let previousScrollY = 0;
const bodyElement = document.querySelector('body');
/* window resize */
const mediaBreakPoint = '(max-width: 1024px)';
const mobileBreakPoint = '(max-width: 540px)';

function classToggle(toggleElement, className) {
    toggleElement.classList.toggle(className);
}

// Calculate and set max-height for featured-submenu panels (mobile only)
function calculateFeaturedSubmenuHeights() {
    const mobileMq = window.matchMedia(mobileBreakPoint);

    if (mobileMq.matches) {
        document.querySelectorAll('.featured-submenu').forEach(submenu => {
            const parentLi = submenu.closest('li.has-submenu');
            const wasOpen = parentLi.classList.contains('featured-submenu-open');

            // Temporarily remove restrictions to measure actual height
            const originalMaxHeight = submenu.style.maxHeight;
            const originalVisibility = submenu.style.visibility;
            const originalOpacity = submenu.style.opacity;
            const originalPosition = submenu.style.position;

            submenu.style.maxHeight = 'none';
            submenu.style.visibility = 'visible';
            submenu.style.opacity = '0';
            submenu.style.position = 'absolute';
            submenu.style.height = 'auto';

            const height = submenu.scrollHeight;

            // Restore original styles
            submenu.style.maxHeight = originalMaxHeight;
            submenu.style.visibility = originalVisibility;
            submenu.style.opacity = originalOpacity;
            submenu.style.position = originalPosition;
            submenu.style.height = '';

            // Store height as CSS variable
            submenu.style.setProperty('--featured-submenu-height', height + 'px');
        });
    }
}

// Helper functions
function isMenuOpen() {
    return bodyElement.classList.contains('menuopen');
}

function closeMenu() {
    bodyElement.style.position = 'initial';
    window.scrollTo(0, previousScrollY);
    bodyElement.classList.remove('menuopen');
}

function closeAllSubnavs() {
    document.querySelectorAll('li.parent.subnav-open').forEach(li => {
        li.classList.remove('subnav-open');
    });
}

function closeAllFeaturedSubmenus() {
    document.querySelectorAll('li.has-submenu.featured-submenu-open').forEach(li => {
        li.classList.remove('featured-submenu-open');
    });
}

// Debounce function for resize handler
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

// Menu toggle handler (consolidated)
document.querySelector('.menu-toggle').addEventListener('click', function() {
    classToggle(bodyElement, 'menuopen');

    if (isMenuOpen()) {
        previousScrollY = window.pageYOffset || document.documentElement.scrollTop;
        bodyElement.style.position = 'fixed';
        // Calculate heights after menu opens
        setTimeout(calculateFeaturedSubmenuHeights, 100);
    } else {
        closeMenu();
    }
});


// Window resize handler (consolidated and debounced)
const handleResize = debounce(function() {
    const mq = window.matchMedia(mediaBreakPoint);
    const mobileMq = window.matchMedia(mobileBreakPoint);

    if (!mq.matches) {
        // Close menu and subnavs when over 1024px
        if (isMenuOpen()) {
            closeMenu();
        }
        closeAllSubnavs();
    }

    // Close featured-submenu panels when over 540px
    if (!mobileMq.matches) {
        closeAllFeaturedSubmenus();
    } else if (isMenuOpen()) {
        // Recalculate heights if menu is open and on mobile
        calculateFeaturedSubmenuHeights();
    }
}, 150);

window.addEventListener('resize', handleResize);

// Handle parent link clicks to toggle subnav (accordion style - only one open at a time)
document.querySelectorAll('li.parent > a').forEach(link => {
    link.addEventListener('click', function(e) {
        const mq = window.matchMedia(mediaBreakPoint);
        const parentLi = this.closest('li.parent');

        if (!mq.matches || !isMenuOpen()) return;

        e.preventDefault();
        const isCurrentlyOpen = parentLi.classList.contains('subnav-open');

        // Close all open subnavs first
        closeAllSubnavs();

        // If this one wasn't open, open it (toggle behavior)
        if (!isCurrentlyOpen) {
            parentLi.classList.add('subnav-open');
        }
    });
});

// Initial calculation
if (isMenuOpen()) {
    calculateFeaturedSubmenuHeights();
}

// Handle submenu-trigger clicks to toggle featured-submenu (accordion style - only one open at a time)
// Only works on mobile (max-width: 540px)
document.querySelectorAll('.submenu-trigger').forEach(trigger => {
    trigger.addEventListener('click', function(e) {
        const mobileMq = window.matchMedia(mobileBreakPoint);
        const parentLi = this.closest('li.has-submenu');

        if (!mobileMq.matches || !isMenuOpen()) return;

        e.preventDefault();
        const isCurrentlyOpen = parentLi.classList.contains('featured-submenu-open');

        // Close all open featured-submenu panels first
        closeAllFeaturedSubmenus();

        // If this one wasn't open, open it (toggle behavior)
        if (!isCurrentlyOpen) {
            parentLi.classList.add('featured-submenu-open');
        }
    });
});